export { FooterCopyright } from './FooterCopyright';
export { FooterDivider } from './FooterDivider';
export type { FooterLinkProps } from './FooterLink';
export { FooterLink } from './FooterLink';
export { FooterLinks } from './FooterLinks';
export { FooterPaymentIcons } from './FooterPaymentIcons';
export type { FooterSectionProps } from './FooterSection';
export { FooterSection } from './FooterSection';
export type { FooterSectionLinkProps } from './FooterSectionLink';
export { FooterSectionLink } from './FooterSectionLink';
export { FooterSections } from './FooterSections';
export { FooterSocial } from './FooterSocial';
export type { FooterSocialLinkProps } from './FooterSocialLink';
export { FooterSocialLink } from './FooterSocialLink';
export type { SiteFooterLink, SiteFooterProps, SiteFooterSection, SiteFooterSocialLink } from './SiteFooter';
export { SiteFooter } from './SiteFooter';

import type { ReactNode } from 'react';
import { cn } from '../utils';

export interface FooterProps {
  children: ReactNode;
  className?: string;
}

export function Footer({ children, className }: FooterProps) {
  return (
    <footer className={cn('mt-auto w-full px-4 pt-3 pb-4 font-body', className)}>
      <div className="mx-auto flex w-full max-w-content-md flex-col items-center gap-4">{children}</div>
    </footer>
  );
}
